import { HeightClass } from '~/utils/enum/classes'
import prependZeroToSingleDigitNumber from '~/utils/math/prependZeroToSingleDigitNumber'
import CurrentValueEditable from './CurrentValueEditable'
import {
  BoxInfoTextComponentStructure,
  PageValue,
  Slash,
  TextCurrentPage,
  TextTotalPages
} from './styles'
import { NavigateSliderInfo } from './type'

interface Props extends NavigateSliderInfo {
  first: number
  current: number
  heightClass?: HeightClass
  showTotalPages?: boolean
  total: number
  color?: string
}

const BoxInfoText = ({
  current,
  total,
  textForCurrent,
  textForTotal,
  currentValueEditable,
  onSubmitDatafield,
  heightClass = 'regular',
  first,
  showTotalPages = true,
  color
}: Props) => {
  return (
    <BoxInfoTextComponentStructure>
      {textForCurrent && (
        <TextCurrentPage heightClass={heightClass} color={color}>
          {textForCurrent}
        </TextCurrentPage>
      )}
      {!currentValueEditable && (
        <PageValue alignRight heightClass={heightClass} color={color}>
          {prependZeroToSingleDigitNumber(current)}
        </PageValue>
      )}
      {currentValueEditable && (
        <CurrentValueEditable
          current={current}
          total={total}
          onSubmit={onSubmitDatafield}
          heightClass={heightClass}
          first={first}
        />
      )}

      {showTotalPages && (
        <Slash heightClass={heightClass} color={color}>
          /
        </Slash>
      )}

      {showTotalPages && (
        <PageValue heightClass={heightClass} color={color}>
          {prependZeroToSingleDigitNumber(total)}
        </PageValue>
      )}

      {showTotalPages && textForTotal && (
        <TextTotalPages heightClass={heightClass} color={color}>
          {textForTotal}
        </TextTotalPages>
      )}
    </BoxInfoTextComponentStructure>
  )
}

export default BoxInfoText
